import React from 'react';
import { HelpCenterLvl_2_1 } from '../../utils/constant';
import HelpCenterTemplate from '../../components/HelpCenterComponents/HelpCenterTemplate';
import { AlliancesHeadings } from '../../components/data/data/HelpCenter/HelpCenterData';

const Alliances = () => {
  return (
    <HelpCenterTemplate
      pageTitle="Alliances"
      sectionTitle="Understanding Spatial Grid & Business Value"
      sectionDescription="Get started"
      articlesData={AlliancesHeadings}
      basePath="/help-center/alliances-articles"
      breadcrumbPath={{
        name: 'Alliances',
        path: '/help-center/alliances',
      }}
      searchPlaceholder="Search the Spatial Grid Help Center"
      showArticleCount={true}
      maxDisplayArticles={3}
      seeAllLink="/help-center/alliances-articles"
    />
  );
};

export default Alliances;
